import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { RegistrationService } from '../components/registration';

@Injectable({ providedIn: 'root' })
export class LandingPageGuard implements CanActivate 
{

	constructor(private router: Router, private registrationService: RegistrationService) { }

	canActivate(): boolean 
	{
		if (localStorage.getItem('userDetails') || this.registrationService.isSavingIndividualUser || localStorage.getItem('tmhCorporateAdminDetails') || localStorage.getItem('tmhCustomerSupportDetails')) 
		{
			this.registrationService.isSavingIndividualUser = false;
			return true;
		}

		this.router.navigate(['/']);
		return false;
	}
}
